import React from 'react';
import { layout, space, typography } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';

const Button = styled.button`
  height: 56px;
  min-width: 140px;
  background: transparent;
  outline: 0;

  & > span {
    color: ${({ isFocused }) =>
      isFocused ? themeGet('colors.primary_600') : themeGet('colors.primary_400')};
    border-radius: 12px;

    padding: 0 ${themeGet('space.s')}px;

    width: 100%;
    height: 100%;

    ${typography}

    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      color: ${themeGet('colors.primary_500')};
    }

    &:focus {
      color: ${themeGet('colors.primary_600')};
    }

    & > .icon-left {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: ${themeGet('space.xs')}px;
    }
  }

  &:focus {
    color: transparent;
  }

  &:disabled {
    opacity: 0.5;
  }

  ${space}
  ${layout}
`;

function BtnLink({
  style,
  title,
  label,
  type,
  onClick,
  disabled,
  isWaiting,
  icon,
  fontSize,
  lineHeight,
  fontWeight,
}) {
  return (
    <Button
      title={title || label}
      aria-label={title || label}
      fontSize={fontSize || 'h4'}
      lineHeight={lineHeight || 'h4'}
      fontWeight={fontWeight || 'bold'}
      {...style}
      type={type}
      disabled={disabled || isWaiting}
      onClick={onClick}
    >
      <span>
        {icon && <span className="icon-left">{icon}</span>}
        {label}
      </span>
    </Button>
  );
}

export default BtnLink;
